<template>
  <VpConfirmModal modalId="quickpassConfirmModal">
    <template v-slot:title>
      <p class="vp-font-weight-700">
        {{ $t("users.form.printQuickpass") }}
      </p>
    </template>

    <template v-slot:text1>
      <span
        v-html="
          $t('users.form.checkKiosk', {
            kiosk: getModalInfo.selectedKiosk || 'kiosk',
          })
        "
      />
    </template>

    <template v-slot:buttons>
      <VpButton :text="$t('common.okay')" @click="onSubmit" />
    </template>
  </VpConfirmModal>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  methods: {
    onSubmit() {
      this.$bvModal.hide("quickpassConfirmModal");
      this.$emit("deselectUsers");
    },
  },
};
</script>
